import MpIcon from "./../components/utils/MpIcons";

import Brt from "./../assets/mp-brt-icon.svg";
import Bus from "./../assets/mp-bus-icon.svg";
import CarRepair from "./../assets/mp-carRepair-icon.svg";
import Entertainment from "./../assets/mp-entertainment-icon.svg";
import FireStation from "./../assets/mp-fireStation-icon.svg";
import Highway from "./../assets/mp-highway-icon.svg";
import Hospital from "./../assets/mp-hospital-icon.svg";
import Institute from "./../assets/mp-institute-icon.svg";
import Metro from "./../assets/mp-metro-icon.svg";
import OilStation from "./../assets/mp-oilStation-icon.svg";
import Park from "./../assets/mp-park-icon.svg";
import Police from "./../assets/mp-police-icon.svg";
import Pool from "./../assets/mp-pool-icon.svg";
import Road from "./../assets/mp-road-icon.svg";
import RoadCamera from "./../assets/mp-roadCamera-icon.svg";
import School from "./../assets/mp-school-icon.svg";
import Shop from "./../assets/mp-shop-icon.svg";
import Sport from "./../assets/mp-sport-icon.svg";
import Taxi from "./../assets/mp-taxi-icon.svg";

const itemsIcons = [
  {
    // terafic
    id: 201,
    icon: <MpIcon name="brt" size="sm" />,
    img: Brt,
    color: "#1874E7",
  },

  {
    // tarh
    id: 203,
    icon: <MpIcon name="roadCamera" size="bg" />,
    img: RoadCamera,
    color: "#FF8024",
  },
  {
    // fuel
    id: 204,
    icon: <MpIcon name="oilStation" size="bg" />,
    img: OilStation,
    color: "#FF8024",
  },
  {
    // cng
    id: 205,
    icon: <MpIcon name="oilStation" size="sm" />,
    img: OilStation,
    color: "#FF8024",
  },
  {
    // metro
    id: 301,
    icon: <MpIcon name="metro" size="bg" />,
    img: Metro,
    color: "#1874E7",
  },
  {
    // brt
    id: 302,
    icon: <MpIcon name="brt" size="bg" />,
    img: Brt,
    color: "#1874E7",
  },
  {
    // bus
    id: 303,
    icon: <MpIcon name="bus" size="bg" />,
    img: Bus,
    color: "#1874E7",
  },
  {
    // taxi
    id: 304,
    icon: <MpIcon name="taxi" size="bg" />,
    img: Taxi,
    color: "#FF8024",
  },
  {
    // school
    id: 401,
    icon: <MpIcon name="school" size="bg" />,
    img: School,
    color: "#FF8024",
  },
  {
    // park
    id: 403,
    icon: <MpIcon name="park" size="bg" />,
    img: Park,
    color: "#2E7E36",
  },
  {
    // pharmacy
    id: 404,
    icon: <MpIcon name="hospital" size="sm" />,
    img: Hospital,
    color: "#C82021",
  },
  {
    // gym
    id: 405,
    icon: <MpIcon name="sport" size="bg" />,
    img: Sport,
    color: "#1874E7",
  },
  {
    // pool
    id: 406,
    icon: <MpIcon name="pool" size="bg" />,
    img: Pool,
    color: "#1874E7",
  },
  {
    // shop
    id: 407,
    icon: <MpIcon name="shop" size="bg" />,
    img: Shop,
    color: "#FF8024",
  },
  {
    // hotel
    id: 409,
    icon: <MpIcon name="shop" size="sm" />,
    img: Shop,
    color: "#FF8024",
  },
  {
    // zoo
    id: 410,
    icon: <MpIcon name="shop" size="sm" />,
    img: Shop,
    color: "#FF8024",
  },
  {
    // police
    id: 501,
    icon: <MpIcon name="police" size="bg" />,
    img: Police,
    color: "#FF8024",
  },
  {
    // fire
    id: 502,
    icon: <MpIcon name="fireStation" size="bg" />,
    img: FireStation,
    color: "#C82021",
  },
  {
    // hospital
    id: 503,
    icon: <MpIcon name="hospital" size="bg" />,
    img: Hospital,
    color: "#C82021",
  },
  {
    // bohran
    id: 505,
    icon: <MpIcon name="hospital" size="sm" />,
    img: Hospital,
    color: "#C82021",
  },
  // {
  //   // aludegi
  //   id: 601,
  //   icon: <MpIcon name="fireStation" size="sm" />,
  //   img: FireStation,
  //   color: "#C82021",
  // },
];
export default itemsIcons;
